/**
 * `/gallery` — this route renders `@sportsmet/ui`'s existing `Gallery`.
 * `tests/e2e/src/gallery.spec.ts` drives it for the L6 visual pass.
 */
import { Gallery } from "@sportsmet/ui/gallery";
import { createFileRoute } from "@tanstack/react-router";

import { requireSignedIn } from "../auth/requireSignedIn";

export const Route = createFileRoute("/gallery")({
  beforeLoad: requireSignedIn,
  component: Gallery,
});
